import { createPermission } from '@backstage/plugin-permission-common';

export const moduleAdminsViewPermission = createPermission({
    name: 'module.admins.view',
    attributes: { action: 'read' }
});